/**
 * 사업자 정보 (시안 `_business.html` 의 `#bizPopup`).
 *
 * 약관 본문(`legal.ts`)과 분리해 둔다. 그쪽은 7만 자가 넘어 별도 청크로 늦게
 * 불러오는데, 회사 소개는 그럴 필요가 없다.
 */
export interface BusinessInfo {
  name: string;
  /** 사업자등록번호 */
  registrationNumber: string;
  address: string;
  email: string;
  /** 표시용 도메인 */
  siteLabel: string;
  siteHref: string;
}

/**
 * ⚠️ 시안 `_business.html` 의 이메일 링크가 `mailto:wmklibrary@gmail.com` 인데
 * 화면에 보이는 글자는 `urnplay.official@gmail.com` 이다. 홈페이지 링크도
 * 표시는 `urnplay.com`, 실제 href 는 `https://wondermusic.kr` 이다.
 * 퍼블리싱 실수로 보여 **보이는 글자 기준**으로 맞췄다. 확인 필요.
 */
export const BUSINESS_INFO: BusinessInfo = {
  name: '(주)원더뮤직코리아',
  registrationNumber: '735-86-00487',
  // 2026-09-21 이전(移轉). 예전 주소: 서울특별시 송파구 법원로 128, 문정 SK V1 C동 613호
  address: '경기도 성남시 분당구 야탑로105번길 7, 5층 (야탑동, 한주빌딩)',
  email: 'urnplay.official@gmail.com',
  siteLabel: 'urnplay.com',
  siteHref: 'https://urnplay.com',
};
